import { createContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import toast, { Toaster } from "react-hot-toast";

import {
  getData,
  postData,
  getEditData,
  editData,
  deleteData,
  getDimension,
} from "./api";

// import { Per_Page_Dropdown, Select2Data, SelectImageData, RequiredIs } from "./common";

export const Context = createContext();
var HtmlToReactParser = require("html-to-react").Parser;
var htmlToReactParser = new HtmlToReactParser();
const AppContext = ({ children }) => {
  // const IMG_URL = "http://127.0.0.1:4327";
  const IMG_URL = "http://192.168.16.183:4327";
  // const IMG_URL = "https://crowdfunding.node.profcyma.org:4327";

  const WEB_URL = "http://192.168.16.183:4327";
  // const WEB_URL = "https://crowdfunding.node.profcyma.org:4327";

  const navigate = useNavigate();

  const [signin, setSignin] = useState(false);
  // const [language, setLanguage] = useState(1);
  const [usertype, setUsertype] = useState("");
  const [userdata, setUserData] = useState({});
  const [isAllow, setisAllow] = useState([]);
  const minLength = 2;
  const maxLength = 30;
  const location = useLocation();
  console.log(signin, "signin");
  console.log(userdata, "userdatauserdata");
  // useEffect(() => {
  //   isTokenValid();
  // }, [signin]);
  useEffect(() => {
    isTokenValid();
  }, []);

  const getuserData = async (id) => {
    const response = await getData(`/user/profile`);

    await setUserData(response?.data);
    await setisAllow(response?.data?.permissions);
  };

  const [user, setUser] = useState({});
  const GetUser = async () => {
    const response = await getData(`/user/profile`);
    if (response?.success) {
      setUser(response?.data);
    }
  };
  useEffect(() => {
    GetUser();
    getuserData();
  }, []);

  const isTokenValid = async () => {
    const token = Cookies.get("aiorigin_website_security");

    if (token) {
      // Decode the token to get the expiration time
      const decodedToken = JSON.parse(atob(token.split(".")[1]));
      const currentTime = Date.now() / 1000;

      // Check if the token has expired
      if (decodedToken.exp < currentTime) {
        Cookies.remove("aiorigin_website_security", { path: "/" });
        setSignin(false);
        setUsertype("");
        setisAllow([]);
        navigate("/");
        console.log("I am in exp");
      } else {
        setisAllow(decodedToken?.permissions);
        await getuserData(decodedToken.user);
        setUsertype(decodedToken.rolename);
        setSignin(true);
        console.log("I am in success");
      }
    } else {
      setSignin(false);
      setUsertype("");
      setisAllow([]);
      // navigate(location.pathname === "/sign-up" ? "/sign-up" : "/login");
      // navigate(location.pathname === "/sign-up" ? "/sign-up" : "/");

      console.log("I am in false");
    }
  };

  // const isTokenValid = async () => {
  //   const token = Cookies.get("aiorigin_website_security");

  //   if (token) {
  //     const decodedToken = JSON.parse(atob(token.split(".")[1]));
  //     const currentTime = Date.now() / 1000;

  //     if (decodedToken.exp < currentTime) {
  //       Cookies.remove("aiorigin_website_security", { path: "/" });
  //       navigate("/Components/DashBoard/DashBoard");
  //     } else {
  //       getuserData(decodedToken.user);
  //       setUsertype(decodedToken.role);
  //       setSignin(true);
  //     }
  //   } else {
  //     navigate("/Components/DashBoard/DashBoard");
  //   }
  // };

  const ErrorNotify = (name) => {
    toast.error(`${name} deleted successfully.`, {
      position: "top-right",
      autoClose: 100,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "dark",
      style: { background: "red", color: "white" },
    });
  };

  // Togle
  const [isSidebarOpen, setSidebarOpen] = useState(true);
  const toggleSidebar = () => {
    setSidebarOpen(!isSidebarOpen);
  };
  return (
    <Context.Provider
      value={{
        IMG_URL,
        getData,
        postData,
        // getEditData,
        // editData,
        deleteData,
        // minLength,
        // maxLength,
        signin,
        setSignin,
        // usertype,
        // setUsertype,
        userdata,
        // setUserData,
        // getDownloadDataExcel,
        // ErrorNotify,
        // token,
        // setToken,
        toggleSidebar,
        isSidebarOpen,
        setSidebarOpen,
        // Select2Data,
        // SelectImageData,
        // Per_Page_Dropdown,
        // RequiredIs,
        getDimension,
        // isAllow,
        // user,
        htmlToReactParser,
        WEB_URL,
        getuserData,
      }}
    >
      {children}
    </Context.Provider>
  );
};

export default AppContext;
